import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import './../../../styles/global.scss';
import Skeleton from 'react-loading-skeleton';

class PiechartComponent extends Component {

        state = {
            chartData: {
                labels: this.props.labels || <Skeleton />,
                datasets: [{
                    label: 'Test',
                    data: this.props.data || <Skeleton />,
                    backgroundColor: [
                        'rgba(122,191,128, 1)',
                        'rgba(224,0,105, 1)',
                        
                        'rgba(122,33,130, 1)',
                        'rgba(238, 112, 33, 1)',
                        'rgba(0, 113, 185,1)',
                        'rgba(219, 220, 43, 1)',
                        'rgba(0, 56, 67,1)',
                    ],
                    borderColor: '#fff'
                }]
            }
        }
        

    render() {
        return (
            <div className="chart">

                <Pie
                    width={0}
                    responsive={true}
                    data={this.state.chartData || <Skeleton />}
                    options={{
                        title: {
                            display: true,
                            text: this.props.title || <Skeleton />
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }}
                />
            </div>
        )
    }
    componentDidMount = () => {

    }

}

export default PiechartComponent;